import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material';

import Container from '@/components/Container';


const Panel: ComponentType<HTMLAttributes<HTMLDivElement>> = styled(Container)`
  background-color: #FAFAFA;
  border-bottom: solid 1px #DFE1E6;
  margin: 0px;
  color: #091E42;
  height: 53px;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0px 20px;
`;

export default Panel;